import { EndpointSetting } from "@/constants/app/type";
import { FlightState } from "../type";

export const callbackFareRulesFeeConditions: EndpointSetting['caller'] = (
  state: FlightState,
  action: any,
  endpointName: any
) => {
  state.get_fare_rule_fee_conditions.loading = false
  state.get_fare_rule_fee_conditions.error = null
  state.get_fare_rule_fee_conditions.success = true

  const key = action.meta.arg.body.fareData[0].flights[0].flightValue

  state.get_fare_rule_fee_conditions.data[key] = action.payload
  // for (let i = 0; i < action.payload.length; i++) {
  //   const fareRule = action.payload[i];
  //   state.get_fare_rule_fee_conditions.data[fareRule.airline] = fareRule
  //   state.get_fare_rule_fee_conditions.data[fareRule.airline].listFareRules = fareRule.listFareRules.reduce((obj1: any, fareRuleItem: any) => {
  //     const ruleNumber = fareRuleItem.ruleNumber.toUpperCase().split(/\s+/).join('')
  //     obj1[ruleNumber] = fareRuleItem
  //     return obj1
  //   }, {})
  // }
}